import { Injectable } from '@angular/core';
import { DocumentRequirement, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import {
    UTILS_ICON_BOX_OPEN,
    UTILS_ICON_FUNNEL_DOLLAR,
    UTILS_ICON_HANDSHAKE,
    UTILS_ICON_SQUARE_QUESTION,
    UTILS_ICON_SUITCASE,
    UTILS_ICON_USER,
} from '@wdx/shared/utils';

@Injectable({ providedIn: 'root' })
export class DocumentChecklistRelatedToService {
    getRelatedTo(documentRequirement: DocumentRequirement): {
        icon: string;
        name: string;
        id: string;
    } {
        const related = this.relatedTarget(documentRequirement);

        return {
            icon: related.icon ?? UTILS_ICON_SQUARE_QUESTION,
            name: related.name ?? 'Other',
            id: related.id ?? '',
        };
    }

    getRelatedEntity(documentRequirement: DocumentRequirement): {
        type?: SystemEntity;
        id?: string;
    } {
        const related = this.relatedTarget(documentRequirement);

        return {
            type: related.type,
            id: related.id,
        };
    }

    private relatedTarget(documentRequirement: DocumentRequirement): {
        type?: SystemEntity;
        id?: string;
        name?: string;
        icon?: string;
    } {
        let entityType = documentRequirement.requirementType?.targetEntityType;

        switch (entityType) {
            case SystemEntity.Person:
            case SystemEntity.Organisation:
                entityType = SystemEntity.Party;
                break;
            case SystemEntity.Portfolio:
                entityType = SystemEntity.ClientProduct;
                break;
        }

        switch (entityType) {
            case SystemEntity.Party:
                return {
                    type: SystemEntity.Party,
                    icon: UTILS_ICON_USER,
                    name: documentRequirement.party?.name,
                    id: documentRequirement.party?.id,
                };

            case SystemEntity.ClientProduct:
                return {
                    type: SystemEntity.ClientProduct,
                    icon: UTILS_ICON_BOX_OPEN,
                    name: documentRequirement.clientProduct?.name,
                    id: documentRequirement.clientProduct?.id,
                };

            case SystemEntity.Case:
                return {
                    type: SystemEntity.Case,
                    icon: UTILS_ICON_SUITCASE,
                    name: documentRequirement.case?.name,
                    id: documentRequirement.case?.id,
                };

            case SystemEntity.Client:
                return {
                    type: SystemEntity.Client,
                    icon: UTILS_ICON_HANDSHAKE,
                    name: documentRequirement.client?.name,
                    id: documentRequirement.client?.id,
                };

            case SystemEntity.Opportunity:
                return {
                    type: SystemEntity.Opportunity,
                    icon: UTILS_ICON_FUNNEL_DOLLAR,
                    name: documentRequirement.opportunity?.name,
                    id: documentRequirement.opportunity?.id,
                };

            default:
                return {};
        }
    }
}
